import React, { useEffect, useState } from 'react';

import { Box, TextField } from '@mui/material';

import { RuleCondition } from '~/consts/agentHub';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => void;
  existingConditions: RuleCondition['value'];
}

function AgentHubCommissionsMinTotalSpendInput({ setCreatedConditions, existingConditions }: Props) {
  const initialNumeric = (existingConditions?.[0]?.value as number) ?? 0;
  const [inputValue, setInputValue] = useState(() => String(initialNumeric));

  useEffect(() => {
    const minSpend =
      inputValue === ''
        ? 0
        : (() => {
            const parsed = parseInt(inputValue, 10);
            return Number.isNaN(parsed) ? 0 : parsed;
          })();
    setCreatedConditions(
      {
        type: 'minTotalSpend',
        value: [{ label: 'Min', value: minSpend }],
      },
      true,
    );
  }, [inputValue, setCreatedConditions]);

  return (
    <Box>
      <TextField
        required
        name="minTotalSpend"
        value={inputValue}
        onChange={(e) => {
          const digitsOnly = e.target.value.replace(/\D/g, '');
          if (digitsOnly === '') {
            setInputValue('');
            return;
          }
          const parsed = parseInt(digitsOnly, 10);
          setInputValue(Number.isNaN(parsed) ? '' : String(parsed));
        }}
        onBlur={() => {
          if (inputValue === '') {
            setInputValue('0');
          }
        }}
        slotProps={{
          input: {
            inputProps: { inputMode: 'numeric', autoComplete: 'off' },
            sx: { borderRadius: 0.5 },
          },
        }}
        label="Min total spend"
        type="text"
        fullWidth
      />
    </Box>
  );
}

export default AgentHubCommissionsMinTotalSpendInput;
